import { TargetAudienceBanner } from 'features/homePage/TargetAudienceBanner';

export const HomeBanner = () => {
  return <TargetAudienceBanner />;
};
